import { store as giscubeStore } from '@giscube/geoportal'

import state from './state'
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

const giscubeModule = giscubeStore.modules.search

export default {
  namespaced: true,
  getters: {
    ...giscubeModule.getters,
    ...getters
  },
  mutations: {
    ...giscubeModule.mutations,
    ...mutations
  },
  actions: {
    ...giscubeModule.actions,
    ...actions
  },
  state: {
    ...giscubeModule.state,
    ...state
  }
}
